<h2 class="mt-3">{{ 'choose.options' | translate }}</h2>
<fieldset>
  <div class="is-flex is-align-items-center gap-xs">
    <img
      class="logo"
      src="/soins.png"
      alt="icone soins"
      height="48"
      width="48" />
    <h3>{{ 'tarificateur.medicalcare' | translate }}</h3>
  </div>
  <p class="mb-3">{{ 'option.minsilver' | translate }}</p>
  <mat-radio-group
    [formControl]="fc"
    class="is-flex is-flex-direction-column gap-s">
    <acs-expandable-radio-button
      (expandedChange)="expandPanel(0)"
      [expanded]="expandedOption === 0"
      [canExpand]="false">
      <mat-radio-button
        [value]="options[0].level"
        [disabled]="options[0].disable">
        <span class="is-size-6">{{ options[0].label | translate }}</span>
      </mat-radio-button>
    </acs-expandable-radio-button>
    <acs-expandable-radio-button
      (expandedChange)="expandPanel(1)"
      [expanded]="expandedOption === 1">
      <mat-radio-button
        [value]="options[1].level"
        [disabled]="options[1].disable">
        <span class="is-size-6">{{ options[1].label | translate }}</span>
      </mat-radio-button>

      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.doctor_fees.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.doctor_fees.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.analysis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.analysis.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.kinesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.kinesis.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.fake_medicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.fake_medicine.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.prothesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.prothesis.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.checkup.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.checkup.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.cancer_prevention.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.cancer_prevention.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.automedicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.automedicine.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.nutrition.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.nutrition.description.lv1' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
    <acs-expandable-radio-button
      (expandedChange)="expandPanel(2)"
      [expanded]="expandedOption === 2">
      <mat-radio-button
        [value]="options[2].level"
        [disabled]="options[2].disable">
        <span class="is-size-6">{{ options[2].label | translate }}</span>
      </mat-radio-button>

      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.doctor_fees.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.doctor_fees.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.analysis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.analysis.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.kinesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.kinesis.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.fake_medicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.fake_medicine.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.prothesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.prothesis.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.checkup.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.checkup.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.cancer_prevention.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.cancer_prevention.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.automedicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.automedicine.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.nutrition.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.nutrition.description.lv2' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
    <acs-expandable-radio-button
      (expandedChange)="expandPanel(3)"
      [expanded]="expandedOption === 3">
      <mat-radio-button
        [value]="options[3].level"
        [disabled]="options[3].disable">
        <span class="is-size-6">{{ options[3].label | translate }}</span>
      </mat-radio-button>

      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.doctor_fees.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.doctor_fees.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.analysis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.analysis.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.kinesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.kinesis.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.fake_medicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.fake_medicine.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.prothesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.prothesis.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.checkup.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.checkup.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.cancer_prevention.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.cancer_prevention.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.automedicine.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.automedicine.description.lv3' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.medical_care.nutrition.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.medical_care.nutrition.description.lv3' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
  </mat-radio-group>
</fieldset>
